@if (data.loading) {
  <loader></loader>
}
@if (data.list.length > 0) {
  <ul>
    @for (item of data.list | slice:0:3; track item) {
      <li>
        <a [routerLink]="'/töölaud/teavitused/' + item.id" class="message" [class.unread]="!item.read"
          [attr.data-test-id]="'sidebar-notifications-item-' + item?.id">
          <span>{{item.subject}}</span>
          <p>{{item.sentAt | date:"dd.MM.yyyy"}} {{'notifications_block.time' | translate}} {{item.sentAt | date:"HH:mm"}}</p>
        </a>
      </li>
    }
  </ul>
}
@if (data.list.length === 0 && !data.loading) {
  <ul class="no-messages">
    <li>
      {{ 'frontpage.dashboard_no_notifications' | translate }}
    </li>
  </ul>
}
<div class="bottom" [hidden]="data.list.length === 0">
  <a routerLink="{{ '/töölaud/teavitused' | translatePath }}"
    data-test-id="sidebar-notifications-link"
  >{{ 'frontpage.dashboard_view_all_notifications' | translate }}</a>
</div>
